import { Avatar, Flexbox } from '@/components'
import dateMask from '@/lib/masks/date'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

function messagePreview(message) {
  const description = message?.description || ''
  return description.length > 60 ? `${description.substring(0, 60)}...` : description
}

function hasAttachment(message) {
  return Boolean(message?.attachmentURL || message?.images?.length || message?.images)
}

function fairPath(conversation) {
  return `/app/adoption-fairs/${conversation.fairId}`
}

function petPath(conversation) {
  return `/app/adoption-fairs/${conversation.fairId}/pets/${conversation.resourceId}`
}

function chatPath(conversation) {
  return `/app/adoption-fairs/messages/${conversation.conversationId}`
}

function Row({ conversation, search }) {
  return (
    <tr className={conversation.unreads > 0 ? 'text-bold' : ''}>
      <td>
        <Flexbox.Columns className="align-center col-gapless">
          <Flexbox.Column className="col-auto">
            <Avatar
              className="mr-1"
              name={conversation?.animal?.name || conversation?.title}
              photoURL={conversation?.animal?.photoURL}
              smart={false}
              alt="Imagem da conversa"
            />
          </Flexbox.Column>
          <Flexbox.Column className="ml-1">
            <div>
              <Link to={petPath(conversation)}>
                {conversation?.animal?.name || conversation?.title}
              </Link>
            </div>
          </Flexbox.Column>
        </Flexbox.Columns>
      </td>
      <td>
        <Flexbox.Columns className="align-center col-gapless">
          <Flexbox.Column className="col-auto">
            <Avatar
              className="mr-1"
              name={conversation?.lastMessage?.author?.fullName}
              photoURL={conversation?.lastMessage?.author?.photoURL}
              alt="Imagem do autor"
            />
          </Flexbox.Column>
          <Flexbox.Column className="ml-1">
            <div>
              <span>{conversation?.lastMessage?.author?.fullName}</span>
              {
                conversation.unreads > 0 && (
                  <span className="badge ml-2" data-badge={conversation.unreads} />
                )
              }
            </div>
            <small>
              {messagePreview(conversation?.lastMessage)}
              {
                hasAttachment(conversation?.lastMessage)
                  ? <><i className="fas fa-image ml-1" />&nbsp;Imagem</>
                  : null
              }
            </small>
            <div>
              <small>{dateMask(conversation?.lastMessage?.createdAt)}</small>
            </div>
          </Flexbox.Column>
        </Flexbox.Columns>
      </td>
      <td>
        {
          conversation?.participants?.map((person) => (
            <div key={person.id}>
              <Avatar
                avatarSize="xs"
                className="mr-1"
                name={person?.fullName}
                photoURL={person?.photoURL}
                alt="Imagem do participante"
              />
              {person?.fullName}
            </div>
          ))
        }
      </td>
      <td>
        <Link to={fairPath(conversation)}>
          {conversation?.fair?.title || `Feira #${conversation.fairId}`}
        </Link>
      </td>
      <td>
        <div className="d-flex align-center" style={{ justifyContent: 'flex-end' }}>
          <Link
            to={{
              pathname: chatPath(conversation),
              search,
              state: { conversation },
            }}
            className="btn btn-action btn-sm btn-primary"
          >
            <i className="fas fa-eye" />
          </Link>
        </div>
      </td>
    </tr>
  )
}

Row.propTypes = {
  conversation: PropTypes.objectOf(PropTypes.any).isRequired,
  search: PropTypes.string.isRequired,
}

export default Row
